// A 100% deposit equals paying in full, so it must never be offered as a
// separate "deposit" choice. Deposit is selectable only for a partial
// prepayment (0 < percentage < 100).
//
// NOTE: kept in sync with apps/customer/src/utils/prepayment.ts (the two widget
// and customer apps don't share a utils package). Update both if the rule changes.
export function isDepositPaymentSelectable<
  T extends { percentage?: number },
>(prePayment: T | null | undefined): prePayment is T {
  const percentage = prePayment?.percentage ?? 0;
  return !!prePayment && percentage > 0 && percentage < 100;
}
